import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const List = ({ list }) => {

    const clickLinkFooter = (action, tag) => {
        TagManagerService.footer(action, tag);
    }

    return (
        <ul className={'footer-nav-links'}>
            {list.links.map((link) =>
                <li className='footer-nav-item' key={link.title.trim()} onClick={() => clickLinkFooter(list.title, link.title)}>
                    <Link to={link ? link.url : '/'} target={link.target || '_self'} className={'footer-nav-link mobile-click ' + (link.phone ? ' footer-nav-link-number ' : '')}>{link.title}</Link>
                    {link.phone && <span className='footer-nav-number'>{link.phone}</span>}
                </li>
            )}
        </ul>
    )
}

List.propTypes = {
    list: PropTypes.object
}

export default List